import React, { useState, useLayoutEffect, useCallback } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Phone from '@/types/Phone.type';
import PhoneService from '@/services/Phone.service';
import { Box, Grid, IconButton, Table } from '@mui/material';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import Loading from '@/components/common/Loading';
import PageTitle from '@/components/common/PageTitle';
import { useNavigate } from 'react-router-dom';
import URL from '@/common/routes/Url';

type DelType = {
  id: number;
  number: string;
};

const PhoneList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [phones, setPhones] = useState<Array<Phone>>([]);
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [deletInfo, setDeleteInfo] = useState<DelType>({ id: 0, number: '' });

  const getPhones = useCallback(() => {
    PhoneService.getAll()
      .then((response) => {
        setPhones(response.data);
        setIsLoading(false);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });
  }, []);

  useLayoutEffect(() => {
    getPhones();
  }, []);

  const editPhone = (id: number) => {
    navigate(`${URL.phones}/${id}/`);
  };

  const deletePhone = async (id: number) => {
    try {
      await PhoneService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
    getPhones();
  };

  const handleDialog = (id: number, number: string) => {
    setDeleteInfo({
      id: id,
      number: number,
    });
    setIsOpen(true);
  };

  const createPhoen = () => {
    navigate(`${URL.phones}/add`);
  };

  if (isloading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>共有電話マスタ</PageTitle>
        </Box>
        <Box sx={{ marginBottom: '8px' }}>
          <Button variant="contained" color="primary" onClick={() => createPhoen()}>
            追加画面へ
          </Button>
        </Box>
        <TableContainer component={Paper}>
          <Table aria-label="simple table" size="small">
            <TableHead>
              <TableRow>
                <TableCell>電話番号</TableCell>
                <TableCell width="150"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {phones.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.number}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => editPhone(row.id)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDialog(row.id, row.number)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ConfirmDialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          onOk={() => {
            setIsOpen(false);
            deletePhone(deletInfo.id);
          }}
        >
          {deletInfo.number}を本当に削除しますか？
        </ConfirmDialog>
      </Grid>
    </Grid>
  );
};
export default PhoneList;
